import type { RouteRecordRaw } from 'vue-router'

// Routes of the guide area. meta.account: requires a signed-in account.
export const routes: RouteRecordRaw[] = [
  { path: '/exam-guide', name: 'guide', component: () => import('./IndexView.vue') },
  { path: '/syllabus', name: 'syllabus', component: () => import('./SyllabusView.vue') },
]
